import React from 'react';
import {
    getCreateDraftUrlFromFolderId,
    getSubcategoryEditUrl,
    getFolderPinUrl,
} from '../../utilities/urlHelper';
import MoveSubcategoryWrapper from '../move/MoveSubcategoryWrapper';
import BookmarkItem from '../BookmarkItem';
import PinItem from '../page/PinItem';
import { canEditCategory } from '../../utilities/permissionsUtilities';
import CreateOrEditCategoryWrapper from '../create/CreateOrEditCategoryWrapper';

class FolderDropDown extends React.Component {
    render() {
        const { folder, inSubcategory } = this.props;
        return (
            <div className="dropdown dropdown-right-aligned flex-none right" data-disclosure>
                <button className="page-list-dropdown dropdown-link" type="button">
                    <img className="button-icon" alt="dropdown icon" src="/img/icons/dropdown-elipsis.svg" />
                </button>
                <div data-details className="dropdown-overlay" style={{ display: 'none' }} />
                <div data-details className="dropdown-content" style={{ display: 'none' }}>
                    <a className="dropdown-option" href={getCreateDraftUrlFromFolderId(folder.id)}>New page</a>
                    <BookmarkItem folderId={folder.id} bookmarkId={folder.bookmark_id} />
                    <MoveSubcategoryWrapper subcategory={folder} />
                    {canEditCategory()
                    && (
                        <CreateOrEditCategoryWrapper folder_id={folder.id} category_id={folder.category_id}>
                            <span className="dropdown-option link">Edit subcategory</span>
                        </CreateOrEditCategoryWrapper>
                    )}
                    <PinItem pinToCategoryId={folder.category_id} pinToFolderId={folder.folder_id} isPinned={folder.is_pinned} subcategoryId={folder.id} pinId={folder.rank_id} />
                    <span className="dropdown-option do-cancel link" type="button" aria-label="Cancel" role="button">Cancel</span>
                </div>
            </div>
        );
    }
}

export default FolderDropDown;
